import EmailInteractionsToken from '@admin/tokens/email_interactions'
import ContactAvatar from '@apps/crm/admin/tokens/contact_avatar'
import EmailOutcomeToken from '@admin/tokens/email_outcome'
import EmailTypeToken from '@admin/tokens/email_type'
import Avatar from '@admin/components/avatar'
import Logo from '@admin/components/logo'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class EmailToken extends React.Component {

  static propTypes = {
    email: PropTypes.object,
    perspective: PropTypes.string,
    show_interactions: PropTypes.bool,
    show_timestamp: PropTypes.bool
  }

  render() {
    const { email, perspective, show_timestamp, show_interactions, show_outcome } = this.props
    const type = this._getType(email)
    return (
      <div className="email-token">
        <div className="email-token-avatar">
          { type === 'incoming' && email.from &&
            <ContactAvatar { ...email.from } width="32" />
          }
          { perspective === 'contact' && email.program &&
            <Logo team={ email.program } width="32" />
          }
          { perspective === 'queue' && email.contact &&
            <ContactAvatar { ...email.contact } width="32" />
          }
          { perspective === 'program' && email.contact &&
            <ContactAvatar { ...email.contact } width="32" />
          }
          { perspective === 'program' && !email.contact && email.user &&
            <Avatar user={ email.user } width="32" presence={ false } />
          }
          { type === 'automation' && perspective === 'user' && email.program &&
            <Logo team={ email.program } width="32" />
          }
          { type === 'automation' && perspective === 'program' && !email.user && !email.contact &&
            <Avatar icon="envelope" width="32" />
          }
          { type === 'system' && !email.contact && !email.program &&
            <Logo team={{ name: 'Maha', logo: '/images/maha.png' }} width="32" />
          }
        </div>
        <div className="email-token-details">
          <EmailTypeToken type={ type } />
          <div className="email-token-row">
            <div className="email-token-recipient">
              { type === 'automation' && perspective === 'program' && email.user &&
                <>{ email.user.full_name }</>
              }
              { type === 'automation' && perspective === 'program' && email.contact &&
                <>{ email.contact.display_name === 'Unknown' ? email.to[0].address : email.contact.display_name }</>
              }
              { type === 'automation' && perspective === 'program' && !email.user && !email.contact &&
                <>{ email.to[0].address }</>
              }
              { type === 'automation' && perspective !== 'program' && email.program &&
                <>{ email.program.title }</>
              }
              { type === 'campaign' && perspective === 'queue' &&
                <>{ email.to[0].rfc822 }</>
              }
              { type === 'campaign' && perspective === 'program' && email.contact &&
                <>{ email.contact.display_name === 'Unknown' ? email.to[0].address : email.contact.display_name }</>
              }
              { type === 'campaign' && perspective === 'contact' && email.program &&
                <>{ email.program.title }</>
              }
              { type === 'system' && !email.contact && !email.program &&
                <>Maha</>
              }
              { type === 'system' && perspective === 'program' && email.contact &&
                <>{ email.contact.display_name === 'Unknown' ? email.to[0].address : email.contact.display_name }</>
              }
              { type === 'system' && perspective !== 'program' && email.program &&
                <>{ email.program.title }</>
              }
              { type === 'incoming' &&
                <>{ email.from.name || email.from.address }</>
              }
            </div>
            { show_timestamp !== false &&
              <div className="email-token-timestamp">
                { email.sent_at ?
                  <>{ this._getTimestamp() }</> :
                  <T text="t(SENDING)" />
                }
              </div>
            }
          </div>
          <div className="email-token-row">
            <div className="email-token-subject">
              { email.subject }
            </div>
          </div>
          { show_interactions !== false &&
            <EmailInteractionsToken email={ email } />
          }
          { (show_outcome && email.outcome) &&
            <EmailOutcomeToken email={ email } />
          }
        </div>
      </div>
    )
  }

  _getTimestamp() {
    const { email } = this.props
    const timestamp = moment(email.sent_at)
    const today = moment()
    const yesterday = moment().subtract(1, 'day')
    if(timestamp.isSame(today, 'day')) return timestamp.format('h:mm A')
    if(timestamp.isSame(yesterday, 'day')) return 'Yesterday'
    return timestamp.format('MM/DD/YY')
  }

  _getType(email) {
    if(email.type) return email.type
    if(email.email_id) return 'automation'
    if(email.email_campaign_id) return 'campaign'
    if(email.type === 'incoming') return 'incoming'
    return 'system'
  }

}

export default EmailToken
